export const formatPrice = (
    value,
    locale = "en-US",
    currency = "USD",
    options = { minimumFractionDigits: 2, maximumFractionDigits: 2 }
  ) => {
    const numberValue = Number(value);
  
    if (isNaN(numberValue)) {
      console.warn("Invalid number passed to formatPrice:", value);
      return "";
    }
  
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      ...options,
    }).format(numberValue);
  };
  